import { render, staticRenderFns } from "./analysis-report-folder.vue?vue&type=template&id=f56be448&"
import script from "./analysis-report-folder.vue?vue&type=script&lang=ts&"
export * from "./analysis-report-folder.vue?vue&type=script&lang=ts&"
import style0 from "./analysis-report-folder.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports